export default __webpack_public_path__ + "static/media/logo_multicar_rect.4a75bc91.webp";